'use strict';


var Module = class {
	
	constructor() {
		this.name = 'mvc-myquote';
		this.current_version = "1.01.1.2020.12.05";
		
		this.global = null; // put by global on registration
		this.app = null;
		
		this.controllers = null;

		this.isready = false;
		this.isloading = false;

		this.clientapicontrollers = null; // API gateway
	}
	
	init() {
		console.log('module init called for ' + this.name);

		var global = this.global;
		
		this.isready = true;
	}
	
	// compulsory  module functions
	loadModule(parentscriptloader, callback) {
		console.log('loadModule called for module ' + this.name);
		
		if (this.isloading)
			return;
			
		this.isloading = true;

		var self = this;

		var modulescriptloader = parentscriptloader.getChildLoader('mvcmyquoteloader');

		modulescriptloader.load_scripts(function() { self.init(); if (callback) callback(null, self); });

		return modulescriptloader;	
	}
	
	isReady() {
		return this.isready;
	}

	hasLoadStarted() {
		return this.isloading;
	}

	// optional module functions
	registerHooks() {
		console.log('module registerHooks called for ' + this.name);
		
		var global = this.global;
		
		// initialization
	}
	
	postRegisterModule() {
		console.log('postRegisterModule called for ' + this.name);
		if (!this.isloading) {
			var global = this.global;
			var self = this;
			var rootscriptloader = global.getRootScriptLoader();
			
			this.loadModule(rootscriptloader, function() {
				if (self.registerHooks)
				self.registerHooks();
			});
		}
	}
	
	_getClientAPI() {
		if (this.clientapicontrollers)
			return this.clientapicontrollers;
		
		var global = this.global;
		
		var mvcmodule = global.getModuleObject('mvc');
		
		this.clientapicontrollers = mvcmodule._getClientAPI();
		
		return  this.clientapicontrollers;
	}

	//
	// hooks
	//
	

	//
	// API
	//


	// TODO: should use mvcmodule.t for version >= 0.20.7
	t(string) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.t(string);
	}


	//
	// Session functions
	//

	async createChildSession(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var childsession = await _apicontrollers.createChildSessionObject(session);

		if (!childsession)
			return Promise.reject('could not create child session');
			
		childsession.MYQUOTE = this.current_version;
			
		return childsession.getSessionUUID();
	}


	// TODO: should use mvcmodule._getChildSessionOnWeb3Url for version >= 0.20.7
	// keep
	async _getChildSessionOnWeb3Url(parentsession, web3providerurl) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule._getChildSessionOnWeb3Url(parentsession, web3providerurl);
	}

	// TODO: should use mvccurrencies._getChildSessionOnScheme
	async _getChildSessionOnScheme(parentsession, scheme) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		if (!parentsession)
			return Promise.reject('could not find create child of null session');

		var schemesessionmap = parentsession.getSessionVariable('schemesessionmap');
		
		if (!schemesessionmap) {
			schemesessionmap = Object.create(null);
			parentsession.setSessionVariable('schemesessionmap', schemesessionmap);
		}
		
		// we could look if a pre-existing session with corresponding web3providerurl could be re-used
		var schemeuuid = scheme.getSchemeUUID();

		if (schemesessionmap[schemeuuid])
			return schemesessionmap[schemeuuid];

		// else we create one and set it
		var childsession = await _apicontrollers.createChildSessionObject(parentsession);
		childsession.MYQUOTE = this.current_version;

		if (!parentsession.MYQUOTE_ROOT)
			parentsession.MYQUOTE_ROOT = this.current_version;

		var networkconfig = scheme.getNetworkConfig();

		await _apicontrollers.setSessionNetworkConfig(childsession, networkconfig);

		schemesessionmap[schemeuuid] = childsession;

		return childsession;
	}


	//
	// Storage
	//

	// TODO: should use mvcmodule.getLocalJsonLeaf for version >= 0.20.7
	async getLocalJsonLeaf(sessionuuid, keys, bForceRefresh) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getLocalJsonLeaf(sessionuuid, keys, bForceRefresh);
	}
	
	// TODO: should use mvcmodule.saveLocalJson for version >= 0.20.7
	async saveLocalJson(sessionuuid, keys, json) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.saveLocalJson(sessionuuid, keys, json);
	}

	// TODO: should use _apicontrollers.readClientSideJson for version >= 0.20.8
	async _readClientSideJson(session, keys) {
		var clientAccess = session.getClientStorageAccessInstance();
		
		const result = new Promise((resolve, reject) => {
			clientAccess.readClientSideJson(keys, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		})
		.catch(err => {
			console.log('error in _readClientSideJson: ' + err);
		});
		
		return result;
	}

	// TODO: should use _apicontrollers.saveClientSideJson for version >= 0.20.8
	async _saveClientSideJson(session, keys, json) {
		var clientAccess = session.getClientStorageAccessInstance();
		
		const result = new Promise((resolve, reject) => { 
			clientAccess.saveClientSideJson(keys, json, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}



	// TODO: should use mvcmodule.hasPrivateKey for version >= 0.20.7
	async hasPrivateKey(sessionuuid, address) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.hasPrivateKey(sessionuuid, address);
	}

	//
	// Ethnode
	//

	// TODO: should use mvccurrencies._canWalletHandleScheme
	_canWalletHandleScheme(wallet, scheme) {
		if (!wallet || !scheme)
			return false;

		if (scheme.isRemote()) {
			var walletschemeuuid = wallet.getSchemeUUID();

			// TODO: we could look if authserver are the same
			if (walletschemeuuid && (walletschemeuuid === scheme.getSchemeUUID()))
				return true;
			else
				return false;
		}
		else {
			return true;
		}

	}

	// TODO: should use mvccurrencies._createMonitoredEthereumTransaction
	async _createMonitoredEthereumTransaction(wallet, card, session, fromaccount) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var transaction = _apicontrollers.createEthereumTransaction(session, fromaccount);

		return transaction;
	}

	//
	// Card encryption functions
	//

	// private key
	async getWalletDecryptingCard(sessionuuid, walletuuid, address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
	
		if (!wallet)
			return;

		var cards = await mvcmodule.getCardsWithAddress(sessionuuid, walletuuid, address).catch(err => {});

		if (!cards)
			return;

		for (var i = 0; i < cards.length; i++) {
			var _privatekey = await mvcmodule.getCardPrivateKey(sessionuuid, walletuuid, cards[i].uuid).catch(err => {});

			if (_privatekey)
				return cards[i];
		}
	}

	// TODO: should use mvcmodule.getCardPrivateKey for version >= 0.20.7
	async getCardPrivateKey(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getCardPrivateKey(sessionuuid, walletuuid, carduuid);
	}

	// TODO: should use mvcmodule.setCardPrivateKey for version >= 0.20.7
	async setCardPrivateKey(sessionuuid, walletuuid, carduuid, privatekey) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.setCardPrivateKey(sessionuuid, walletuuid, carduuid, privatekey);
	}

	// symetric encryption

	// TODO: should use mvcmodule.aesEncryptString for version >= 0.20.7
	async aesEncryptString(sessionuuid, walletuuid, carduuid, plaintext) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.aesEncryptString(sessionuuid, walletuuid, carduuid, plaintext);
	}

	// TODO: should use mvcmodule.aesDecryptString for version >= 0.20.7
	async aesDecryptString(sessionuuid, walletuuid, carduuid, cyphertext) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.aesDecryptString(sessionuuid, walletuuid, carduuid, cyphertext);
	}

	// asymetric encryption
	// TODO: should use mvcmodule.rsaEncryptString for version >= 0.20.7
	async rsaEncryptString(sessionuuid, walletuuid, carduuid, recipientrsapublickey, plaintext) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.rsaEncryptString(sessionuuid, walletuuid, carduuid, recipientrsapublickey, plaintext);
	}
	
	// TODO: should use mvcmodule.rsaEncryptString for version >= 0.20.7
	async rsaDecryptString(sessionuuid, walletuuid, carduuid, senderrsapublickey, cyphertext) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.rsaDecryptString(sessionuuid, walletuuid, carduuid, senderrsapublickey, cyphertext);
	}




	//
	// Scheme functions
	//

	// TODO: should use mvcmodule.getDefaultLocalSchemeInfo for version >= 0.20.7
	async getDefaultLocalSchemeInfo(sessionuuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getDefaultLocalSchemeInfo(sessionuuid);
	}

	// TODO: should use mvcmodule._getAverageTransactionFee for version >= 0.20.7
	// keep until transition to mvc-currencies
	_getAverageTransactionFee(scheme) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule._getAverageTransactionFee(scheme);
	}

	// TODO: should use mvcmodule._getTransactionCredits for version >= 0.20.7
	// remote
	_getTransactionCredits(scheme, transactionunits) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule._getTransactionCredits(scheme, transactionunits);
	}

	// TODO: should use mvcmodule.getSchemeTransactionInfo for version >= 0.20.12
	async getSchemeTransactionInfo(sessionuuid, schemeuuid, level = 0) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});


		var transactioninfo  = {};

		transactioninfo.gasLimit = scheme.getGasLimit(level);
		transactioninfo.gasPrice = scheme.getGasPrice(level);
		transactioninfo.avg_transaction_fee = this._getAverageTransactionFee(scheme);
		transactioninfo.units_threshold = scheme.getTransactionUnitsThreshold();
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var weiamount = ethnodemodule.getWeiFromEther(transactioninfo.avg_transaction_fee);
		var avg_transaction = await this._createDecimalAmount(session, weiamount, 18);
		var credits_threshold = await avg_transaction.multiply(transactioninfo.units_threshold);

		transactioninfo.credits_threshold = await credits_threshold.toInteger();

		return transactioninfo;
	}

	// TODO: should use mvcmodule.oauth2AuthorizeUrl for version >= 0.20.7
	async oauth2AuthorizeUrl(sessionuuid, schemeuuid, params) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.oauth2AuthorizeUrl(sessionuuid, schemeuuid, params);
	}

	async _getUnitsFromCredits(session, scheme, credits) {
		// Note: scheme is not using DecimalAmount to perform
		// safer computations for the moment (2021.03.04 version 0.20.11)
		var units = scheme.getTransactionUnits(credits);
		
		return units;
	}

	async getUnitsFromCredits(sessionuuid, schemeuuid, credits) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		return this._getUnitsFromCredits(session, scheme, credits);
	}

	async _getCreditsFromUnits(session, scheme, units) {
		var global = this.global;

		var sessionuuid = session.getSessionUUID();

		var transactioninfo  = {};

		transactioninfo.avg_transaction_fee = this._getAverageTransactionFee(scheme);
		transactioninfo.units_threshold = scheme.getTransactionUnitsThreshold();
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var weiamount = ethnodemodule.getWeiFromEther(transactioninfo.avg_transaction_fee);
		var avg_transaction = await this.getDecimalAmount(sessionuuid, weiamount, 18);
		var credits_decimal = await avg_transaction.multiply(units);

		var credits = await credits_decimal.toInteger();
		
		return credits;
	}

	async getCreditsFromUnits(sessionuuid, schemeuuid, units) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);

		return this._getCreditsFromUnits(session, scheme, units);
	}

	//
	// Wallet functions
	//

	// TODO: should use mvcmodule.makeWallet for version >= 0.20.7
	async makeWallet(sessionuuid, authname, schemeuuid, password) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.makeWallet(sessionuuid, authname, schemeuuid, password);
	}

	// TODO: should use mvcmodule.makeWalletFromSession for version >= 0.20.7
	async makeWalletFromSession(sessionuuid, schemeuuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.makeWalletFromSession(sessionuuid, schemeuuid);
	}

	// TODO: should use mvcmodule._isAnonymousAsync for version >= 0.20.7
	// remove
	async _isAnonymousAsync(session) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule._isAnonymousAsync(session);
	}

	// TODO: should use mvcmodule._attachSessionToWallet for version >= 0.20.7
	// remove
	async _attachSessionToWallet(session, wallet) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule._attachSessionToWallet(session, wallet);
	}

	// TODO: should use mvcmodule.attachSessionToWallet for version >= 0.20.7
	async attachSessionToWallet(sessionuuid, walletuuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.attachSessionToWallet(sessionuuid, walletuuid);
	}

	// TODO: should use mvcmodule.lockWallet for version >= 0.20.7
	async lockWallet(sessionuuid, walletuuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.lockWallet(sessionuuid, walletuuid);
	}

	//
	// Card functions
	//

	// TODO: should use mvcmodule.getCardListOnWeb3Url for version >= 0.20.7
	async getCardListOnWeb3Url(sessionuuid, walletuuid, web3url) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getCardListOnWeb3Url(sessionuuid, walletuuid, web3url);
	}

	async createCard(sessionuuid, walletuuid, web3providerurl, privatekey) {
		// Note: this is creating local cards
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!web3providerurl)
			return Promise.reject('web3 url is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);


		const card = await _apicontrollers.createWalletCardFromPrivateKey(session, wallet, web3providerurl, privatekey);

		if (!card)
			return Promise.reject('could not create card');

		if (card.isLocked()) {
			await card.unlock();
		}

		const bSave = await card.save();

		if (!bSave)
			return Promise.reject('could not save card');

		var mvcmodule = global.getModuleObject('mvc');
		var cardinfo = {};

		mvcmodule._fillCardInfo(cardinfo, card);
		
		return cardinfo;
	}

	// TODO: should use mvcmodule.getCardSchemeInfo for version >= 0.20.7
	async getCardSchemeInfo(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getCardSchemeInfo(sessionuuid, walletuuid, carduuid);
	}

	// TODO: should use mvcmodule.getCreditBalance for version >= 0.20.8
	async getCreditBalance(sessionuuid, walletuuid, carduuid) {
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		return mvcmodule.getCreditBalance(sessionuuid, walletuuid, carduuid);
	}
	
	// TODO: should use mvcmodule.transferTransactionUnits for version >= 0.20.12
	async transferTransactionUnits(sessionuuid, walletuuid, cardfromuuid, cardtouuid, units, feelevel = 0) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!cardfromuuid)
			return Promise.reject('from card uuid is undefined');
		
		if (!cardtouuid)
			return Promise.reject('to card uuid is undefined');
		
		
		var global = this.global;
		var mvcmodule = this;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
		
		var fromcard = await wallet.getCardFromUUID(cardfromuuid);
		
		if (!fromcard)
			return Promise.reject('could not find card ' + cardfromuuid);

		var tocard = await wallet.getCardFromUUID(cardtouuid);
	
		if (!tocard)
			return Promise.reject('could not find card ' + cardtouuid);
	
	
		var fromaccount = fromcard._getSessionAccountObject();

		if (!fromaccount)
			return Promise.reject('card has no private key ' + cardfromuuid);
		
		var cardsession = await this._getMonitoredCardSession(session, wallet, fromcard);
		var from_card_scheme = fromcard.getScheme();

		// TODO: for version >= 0.20.7 use call to scheme
		//var avg_transaction_fee = from_card_scheme.getAverageTransactionFee();
		var from_card_scheme_uuid = from_card_scheme.getSchemeUUID();
		var transactioninfo = await this.getSchemeTransactionInfo(sessionuuid, from_card_scheme.uuid);
		var avg_transaction_fee = transactioninfo.avg_transaction_fee; // end TODO

		// create transaction object
		var transaction = _apicontrollers.createEthereumTransaction(cardsession, fromaccount);
		
		// parameters
		var ethnodemodule = global.getModuleObject('ethnode');

		var toaddress = tocard.getAddress();
		var weiamount = ethnodemodule.getWeiFromEther(transactioninfo.avg_transaction_fee);
		var ethamount = await this._createDecimalAmount(cardsession, weiamount, 18);
		ethamount.multiply(units);
		var valuestring = await ethamount.toFixedString();

		transaction.setToAddress(toaddress);
		transaction.setValue(valuestring);

		// fee
		var fee = await _apicontrollers.createSchemeFee(from_card_scheme, feelevel);

		transaction.setGas(fee.gaslimit);
		transaction.setGasPrice(fee.gasPrice);

		
		const txhash = await _apicontrollers.sendEthereumTransaction(cardsession, transaction)
		.catch((err) => {
			console.log('error in transferTransactionUnits: ' + err);
		});

		if (!txhash)
		return Promise.reject('could not send ethereum transaction');

		return txhash;
	}

	async _makeWalletCard(session, wallet, scheme, privatekey) {
		// we make client or remote wallets, depending on the scheme
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		if (!wallet)
			return Promise.reject('wallet is not defined');

		if (!scheme)
			return Promise.reject('scheme is not defined');


		var sessionaccount;

		if (privatekey) {
			// create a session account from private key
			if (_apicontrollers.isValidPrivateKey(session, privatekey)) {
				sessionaccount = await _apicontrollers.getSessionAccountFromPrivateKey(session, wallet, privatekey);
			}
	
			if (!sessionaccount)
				return Promise.reject('not a valid private key');
	
		}
		else {
			// we generate a key
			var _privatekey = _apicontrollers.generatePrivateKey();
			
			sessionaccount = await _apicontrollers.getSessionAccountFromPrivateKey(session, wallet, _privatekey);
	
			if (!sessionaccount)
				return Promise.reject('could not generate a private key');
		}

		var walletsession = wallet._getSession();
		var walletuser = walletsession.getSessionUserObject();

		if (!walletuser)
			return Promise.reject('wallet needs to be unlocked');

		
		var address = sessionaccount.getAddress();
		var authname = walletuser.getUserName();
		var password = null;

		// TODO: use _apicontrollers.makeWalletCard for version >= 0.20.8
		//const card_new =  await _apicontrollers.makeWalletCard(session, wallet, scheme, authname, password, address)
		//.catch(err => {
		//	console.log('error in _makeWalletCard: ' + err);
		//});

 		var Card = global.getModuleClass('wallet', 'Card');

		var cardjson = {};
		cardjson.authname = authname;
		cardjson.address = address;
		cardjson.password = password;

		cardjson.uuid = walletsession.guid();;
		cardjson.label = authname;

		const card_new =  Card.readFromJson(wallet, scheme, cardjson);

 /*		// overload card_new methods
		
		// getCardType
		var getCardType_func_org = card_new.getCardType.bind(card_new);

		var getCardType_func_new = () => {
			var _self = card_new;

			var old_card_type = getCardType_func_org();

			var scheme = _self.scheme;
		
			if (scheme.isRemote()) {
				var wallet = _self.wallet;
				var walletschemeuuid = wallet.getSchemeUUID();
				var schemeuuid = scheme.getSchemeUUID();

				if (this._canWalletHandleScheme(wallet, scheme))
					return Card.CLIENT_CARD;
				else
					return Card.REMOTE_CARD
			}
			else
				return Card.CLIENT_CARD;
		};

		card_new.getCardType = getCardType_func_new;

		// _createSession
		var _createSession_func_org = card_new._createSession.bind(card_new);

		var _createSession_func_new = (callback) => {
			var _self = card_new;

			var scheme = _self.scheme;
		
			if (scheme.isRemote()) {
				var wallet = _self.wallet;
				var walletschemeuuid = wallet.getSchemeUUID();
				var schemeuuid = scheme.getSchemeUUID();

				if (this._canWalletHandleScheme(wallet, scheme)) {
					// card has same session than wallet
					_self.session = wallet._getSession();
					
					if (callback)
					callback(null, session);
					
					return Promise.resolve(session);
				}
			}

			return _createSession_func_org(callback);
		}

		card_new._createSession = _createSession_func_new;
		// end overload
 */		

		if (card_new) {
			await card_new.init();

			if (card_new.isLocked()) {
				await card_new.unlock();
			}

			return card_new;
		}
		else
			throw new Error('could not create card');
	}


	async _createWalletCard(session, wallet, scheme, privatekey) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		if (scheme.isRemote() === false)  {
			return _apicontrollers.createWalletCard(session, wallet, scheme, privatekey);
		}
		else {
			var wallettype = wallet.getWalletType();

			switch(wallettype) {
				case 0:
					return Promise.reject('ERR_MISSING_CREDENTIALS');
				case 1:
					var walletschemeuuid = wallet.getSchemeUUID();

					if (this._canWalletHandleScheme(wallet, scheme))
						return this._makeWalletCard(session, wallet, scheme, privatekey);
					else
						return Promise.reject('ERR_MISSING_CREDENTIALS');
				default:
					return Promise.reject('wrong wallet type: ' + wallettype);
			}
	
		}

	}

	async _getCardFromAddressOnScheme(wallet, address, scheme, callback) {
		// TODO: replace for version >= 0.20.7
		var schemeuuid = scheme.getSchemeUUID();

		return wallet.getCardsWithAddress(address).
		then((cardarray) => {
			for (var i = 0; i < (cardarray ? cardarray.length : 0); i++) {
				var cardschemeuuid = cardarray[i].getSchemeUUID();
				
				if (cardschemeuuid == schemeuuid) {
					return cardarray[i];
				}
			}
			
			throw new Error('ERR_CARD_NOT_FOUND');
		});
	}


	//
	// Currency functions
	// ARE GOING TO BE TRANSFERED TO MVC-CURRENCIES
	//

	async _createCurrencyAmount(session, currency, position) {
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies._createCurrencyAmount(session, currency, position);
		//return CurrencyAmount.create(session, currency, position);
	}

	async _createDecimalAmount(session, amount, decimals) {
		var global = this.global;
		
		var mvccurrencies = global.getModuleObject('mvc-currencies');

		return mvccurrencies._createDecimalAmount(session, amount, decimals);
		//return DecimalAmount.create(session, amount, decimals);
	}


	// TODO: should use mvccurrencies.transferCurrencyAmount
	async transferCurrencyAmount(sessionuuid, walletuuid, cardfromuuid, cardtouuid, currencyuuid, currencyamount, feelevel = 0) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		if (!cardfromuuid)
			return Promise.reject('from card uuid is undefined');
		
		if (!cardtouuid)
			return Promise.reject('to card uuid is undefined');

		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();

		var CurrencyAmountClass = global.getModuleClass('currencies', 'CurrencyAmount');
		if ((currencyamount instanceof CurrencyAmountClass) !== true)
		return Promise.reject('wrong currency amount type');

		var amount = await currencyamount.toString();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
		
		var fromcard = await wallet.getCardFromUUID(cardfromuuid);
		
		if (!fromcard)
			return Promise.reject('could not find card ' + cardfromuuid);

		var tocard = await wallet.getCardFromUUID(cardtouuid);
	
		if (!tocard)
			return Promise.reject('could not find card ' + cardtouuid);
	
	
		var fromaccount = fromcard._getSessionAccountObject();

		if (!fromaccount)
			return Promise.reject('card has no private key ' + cardfromuuid);
		
		var cardsession = await this._getMonitoredCardSession(session, wallet, fromcard);
		var from_card_scheme = fromcard.getScheme();

		// transfer parameters
		var toaddress = tocard.getAddress();
		var tokenaddress = currency.address;
		var tokenamount = amount;
	
		// using token account to make transfer
/* 		
		var tokenaccount = await this._getTokenAccountFromAddress(cardsession, fromcard, tokenaddress).catch(err => {});

		// create contact from toaddress
		var name = toaddress;
		var contactinfo = {};
		var tocontact = await _apicontrollers.createContact(cardsession, name, toaddress, contactinfo).catch(err => {});

		await tokenaccount.transferTo(contact, tokenamount)
		.catch(err => {
			console.log('error in transferCurrencyAmount: ' + err);
		});
 */

		// using direct call to ERC20 to speed up call
		var providerurl = await this._getCurrencyWeb3ProviderUrl(cardsession, currency);
		var senderprivatekey = fromaccount.getPrivateKey();
		var recipientaddress = toaddress;
		var fee  = await _apicontrollers.createSchemeFee(from_card_scheme, feelevel);

		var txhash = await _apicontrollers.sendERC20Tokens(cardsession, providerurl, tokenaddress, senderprivatekey, recipientaddress, tokenamount, fee)
		.catch(err => {
			console.log('error in transferCurrencyAmount: ' + err);
		});

		if (!txhash)
			return Promise.reject('could not send currency tokens');

		return txhash;
	}

	async _getCurrencyProvider(session, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!currency)
			return Promise.reject('currency is undefined');
		
		var global = this.global;

		var clientmodule = global.getModuleObject('webclient');

		return clientmodule.getCurrencyProvider(session, currency.uuid);
	}

	async _getCurrencyOps(session, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!currency)
			return Promise.reject('currency is undefined');
		

		// we look if the currency has a provider specified
		var currency_provider = await this._getCurrencyProvider(session, currency);

		if (currency_provider)
			return currency_provider.getOps();
		else
			return {canpay: false};

	}

	async _getCurrencyScheme(session, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!currency)
			return Promise.reject('currency is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		// we look if the currency has a trade scheme specified
		var currencyschemeuuid = (currency.scheme_uuid ? currency.scheme_uuid : null );
		var scheme;

		if (currencyschemeuuid) {
			// a built-in scheme has been specified in currency definition
			scheme = await _apicontrollers.getSchemeFromUUID(session, currencyschemeuuid)
			.catch(err => {});
		}
		else {
			// scheme has probably already been created with web3providerurl
			var web3url = currency.web3providerurl;
			scheme = await _apicontrollers.getSchemeFromWeb3Url(session, web3url)
			.catch(err => {});

			if (!scheme) {
				// if not, we create a local scheme now and save it
				var defaultlocalscheme = await _apicontrollers.getDefaultScheme(session, 0);
				scheme = await defaultlocalscheme.cloneOnWeb3ProviderUrl(web3url)
				.catch(err => {});
			}
		}
	
		return scheme;
	}

	async _getCurrencyWeb3ProviderUrl(session, currency) {
		if (currency.web3providerurl)
			return currency.web3providerurl;
		else {
			var scheme = await this._getCurrencyScheme(session, currency);

			if (scheme)
				return scheme.getWeb3ProviderUrl();
			else
				console.log('currency is badly configured ' + currency.uuid);
		}
	}
	
	async _findCurrencyFromWeb3ProviderUrl(sessionuuid, web3providerurl) {
		// we retun the first one, it is unsafe and 
		// direct use of currencyuuidis recommended
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		var currencies = await this.getCurrencies(sessionuuid);

		for (var i = 0; i < currencies.length; i++) {
			var currency = currencies[i];

			if (currency.web3providerurl) {
				if (currency.web3providerurl == web3providerurl)
				return currency
			}
			else if (currency.scheme_uuid) {
				var scheme = await _apicontrollers.getSchemeFromUUID(session, currency.scheme_uuid)

				if ((scheme) && (scheme.getWeb3ProviderUrl() == web3providerurl))
					return currency;
			}
			else {
				console.log('currency is badly configured ' + currency.uuid);
			}
		}
	}

	async _getPretradeScheme(session, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!currency)
			return Promise.reject('currency is undefined');
		

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		// we look if the currency has a pretrade scheme specified
		var sessionuuid = session.getSessionUUID();
		var pretradeschemeuuid = (currency.pretrade_scheme_uuid ? currency.pretrade_scheme_uuid : null );

		var scheme = await _apicontrollers.getSchemeFromUUID(session, pretradeschemeuuid)
		.catch(err => {});

		if (scheme)
		return scheme;

		// for the moment we return a url on firenze
		// and do not try to find if we have a scheme operating on valueweb3url
		var clientmodule = global.getModuleObject('webclient');

		var builtin_remote_schemes = clientmodule.getBuiltinRemoteSchemes();
		var builtin_local_schemes = clientmodule.getBuiltinLocalSchemes();

		var prestradescheme = builtin_local_schemes.firenze;
	
		scheme = await _apicontrollers.getSchemeFromUUID(session, prestradescheme.uuid);

		return scheme;
	}

	async _filterCurrencies(session, currencies, walletuuid) {
		var _currencies = [];

		for (var i = 0; i < (currencies ? currencies.length : 0); i++) {
			_currencies.push(currencies[i]);
		}

		if (walletuuid) {
			var _apicontrollers = this._getClientAPI();

			var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});

			if (wallet) {
				var walletschemeuuid = wallet.getSchemeUUID();
				var array = [];

				for (var i = 0; i < (currencies ? currencies.length : 0); i++) {
					var currency = currencies[i];

					// if currency has a scheme, check if it is remote and it matches the wallet
					var currencyscheme = await this._getCurrencyScheme(session, currency);
					
					if (currencyscheme && (currencyscheme.isRemote())) {
						var currencyschemeuuid = currencyscheme.getSchemeUUID();
						if (this._canWalletHandleScheme(wallet, currencyscheme)) {
							array.push(currencies[i]);
						}
					}
					else {
						array.push(currencies[i]);
					}
				}
		
				
				_currencies = array;
			}

		}

		return _currencies;
	}

	async loadConfig(configname) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var clientmodule = global.getModuleObject('webclient');

		return clientmodule.loadConfig(configname);
	}

	// TODO: should use mvccurrencies.getCurrencies
	async getCurrencies(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		// look if already stored in the session variables
		var currencies = session.getSessionVariable('currencies');

		if (currencies) {
			// send back a copy
			var _currencies = await this._filterCurrencies(session, currencies, walletuuid);

			return _currencies;
		}
	
		// otherwise retrieve the list of currencies
		var global = this.global;

		var clientmodule = global.getModuleObject('webclient');

		var currencies = clientmodule.getCurrencies();

		var array = Object.values(currencies);

		// fill complementary info
		for (var i = 0; i < (array ? array.length : 0); i++) {
			// ops
			array[i].ops = await this._getCurrencyOps(session, array[i])
			.catch(err => {
				console.log(err);
			});

			// pretrade_explorer_url
			var currency_pretrade_scheme = await this._getPretradeScheme(session, array[i]).catch(e=>{});
			var currency_pretrade_ethnode_conf = (currency_pretrade_scheme ? currency_pretrade_scheme.getEthNodeServerConfig() : null);

			array[i].pretrade_web3_provider_url = (currency_pretrade_ethnode_conf ? currency_pretrade_ethnode_conf.web3_provider_url : null)
			array[i].pretrade_explorer_url = (currency_pretrade_ethnode_conf ? currency_pretrade_ethnode_conf.explorerurl : null)
		}

		// store in session
		session.setSessionVariable('currencies', array);

		// send back a copy
		var _currencies = await this._filterCurrencies(session, array, walletuuid);

		return _currencies;
	}

	// TODO: should use mvccurrencies.getCurrencyFromUUID
	async getCurrencyFromUUID(sessionuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var currencies = await this.getCurrencies(sessionuuid); // all currencies

		for (var i = 0; i < currencies.length; i++) {
			if (currencies[i].uuid === currencyuuid) {
				return currencies[i];
			}
		}
	}

	async _getCurrencyCardList(session, wallet, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!wallet)
			return Promise.reject('wallet is undefined');

		if (!currency)
			return Promise.reject('currency is undefined');

		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');

		var cards = await wallet.getCardList(true);

		var array = [];

		var scheme = await this._getCurrencyScheme(session, currency);

		if (!scheme)
			return Promise.reject('could not find scheme for currency');

		var schemeuuid = scheme.getSchemeUUID();
		var currencyuuid = currency.uuid;

		for (var i = 0; i < (cards ? cards.length : 0); i++) {
			var _crdschemeuuid = cards[i].getSchemeUUID();

			if (_crdschemeuuid == schemeuuid) {
				// check it is not associated to
				// another currency on same schemeuuid
				// looking at XtraData
				let xtradata = cards[i].getXtraData('myquote');

				xtradata = (xtradata ? xtradata : {});
				let _crdcurrencyuuid = xtradata.currencyuuid;

				if (_crdcurrencyuuid && (_crdcurrencyuuid == currencyuuid))
				array.push(cards[i]);
			}
		}
			
		return array;
	}

	async _getCurrencyCard(session, wallet, currency) {
		if (!session)
			return Promise.reject('session is undefined');
		
		if (!wallet)
			return Promise.reject('wallet is undefined');

		if (!currency)
			return Promise.reject('currency is undefined');

		var cards = await this._getCurrencyCardList(session, wallet, currency);
		var card;

		if (cards && cards.length) {
			// look if a card is marked as main card
			for (var i = 0; i < cards.length; i++) {
				var crd = cards[i];

				var xtra = crd.getXtraData('myquote');

				if (xtra && (xtra.maincard === true)) {
					card = crd;
					break;
				}
			}

		}

		return card;
	}

	// TODO: should use mvccurrencies.getCurrencyCard
	async getCurrencyCard(sessionuuid, walletuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);


		var card = await this._getCurrencyCard(session, wallet, currency);

		if (!card)
			return Promise.reject('could not find currency card for wallet ' + walletuuid);


		var mvcmodule = global.getModuleObject('mvc');

		var cardinfo = {uuid: card.getCardUUID()};

		mvcmodule._fillCardInfo(cardinfo, card);

		return cardinfo;
	}

	// TODO: should use mvccurrencies.setCurrencyCard
	async setCurrencyCard(sessionuuid, walletuuid, currencyuuid, carduuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var card = await wallet.getCardFromUUID(carduuid);
	
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		// sift through cards for currency to set the maincard flag accordingly
		var currencycards = await this._getCurrencyCardList(session, wallet, currency);

		for (var i = 0; i < (currencycards ? currencycards.length : 0); i++) {
			let currencycard = currencycards[i];
			let xtradata = currencycard.getXtraData('myquote');

			if (xtradata && (xtradata.maincard === true)) {
				// remove flag
				xtradata.maincard = false;

				currencycard.putXtraData('myquote', xtradata);

				if (currencycard.isLocked()) {
					await currencycard.unlock();
				}
		
				await currencycard.save();
			}

			if (currencycard.getCardUUID() === carduuid) {
				xtradata = (xtradata ? xtradata : {});
				xtradata.maincard = true;

				currencycard.putXtraData('myquote', xtradata);

				if (currencycard.isLocked()) {
					await currencycard.unlock();
				}

				await currencycard.save();
			}

		}
	
	}

	// TODO: should use mvccurrencies.createCurrencyCard
	async createCurrencyCard(sessionuuid, walletuuid, currencyuuid, privatekey) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var scheme = await this._getCurrencyScheme(session, currency);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		// TODO: replace by _apicontrollers.createWalletCard for version >= 0.20.7
		const card = await this._createWalletCard(session, wallet, scheme, privatekey); 
		//const card = await _apicontrollers.createWalletCard(session, wallet, scheme, privatekey);

		if (!card)
			return Promise.reject('could not create card');

		if (card.isLocked()) {
			await card.unlock();
		}

		// set it's associated to currencyuuid in XtraData
		let xtradata = card.getXtraData('myquote');

		xtradata = (xtradata ? xtradata : {});
		xtradata.currencyuuid = currencyuuid;

		card.putXtraData('myquote', xtradata);

		// save
		const bSave = await card.save();

		if (!bSave)
			return Promise.reject('could not save card');

		// set as maincard if it is the first card created
		var currencycards = await this._getCurrencyCardList(session, wallet, currency);

		if (!currencycards || (currencycards.length == 1)) {
			await this.setCurrencyCard(sessionuuid, walletuuid, currencyuuid, card.uuid);
		}

		// return cardinfo
		var mvcmodule = global.getModuleObject('mvc');
		var cardinfo = {};

		mvcmodule._fillCardInfo(cardinfo, card);
		
		return cardinfo;
	}

	// TODO: should use mvccurrencies.getCurrencyCardWithAddress
	async getCurrencyCardWithAddress(sessionuuid, walletuuid, currencyuuid, address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var scheme = await this._getCurrencyScheme(session, currency);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		// look if we have a card with this address
		// TODO: uncomment for version >= 0.20.7
		//var card = await wallet.getCardFromAddressOnScheme(address, scheme)
		var card = await this._getCardFromAddressOnScheme(wallet, address, scheme)
		.catch(err => {
			console.log('error in getCurrencyCardWithAddress ' + err);
		});

		if (card) {
			// return cardinfo
			var mvcmodule = global.getModuleObject('mvc');
			var cardinfo = {};

			mvcmodule._fillCardInfo(cardinfo, card);
			
			return cardinfo;	
		}
		else {
			// we create a read-only card
			return this.createReadOnlyCurrencyCard(sessionuuid, walletuuid, currencyuuid, address);
		}
	}


	// TODO: should use mvccurrencies.createReadOnlyCurrencyCard
	async createReadOnlyCurrencyCard(sessionuuid, walletuuid, currencyuuid, address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var scheme = await this._getCurrencyScheme(session, currency);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		let authname;
		let password;

		const card = await wallet.createCard(scheme, authname, password, address);

		if (!card)
			return Promise.reject('could not create card');

		var cardsession = card._getSession();

		if (!cardsession) {
			await card.init();
		}

		if (card.isLocked()) {
			await card.unlock();
		}

		// set it's associated to currencyuuid in XtraData
		let xtradata = card.getXtraData('myquote');

		xtradata = (xtradata ? xtradata : {});
		xtradata.currencyuuid = currencyuuid;

		card.putXtraData('myquote', xtradata);

		// save
		const bSave = await card.save();

		if (!bSave)
			return Promise.reject('could not save card');

		// return cardinfo
		var mvcmodule = global.getModuleObject('mvc');
		var cardinfo = {};

		mvcmodule._fillCardInfo(cardinfo, card);
		
		return cardinfo;	
	}

	// TODO: should use mvccurrencies.generateCurrencyCard
	async generateCurrencyCard(sessionuuid, walletuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		// we generate a key
		var _privatekey = _apicontrollers.generatePrivateKey(session);

		return this.createCurrencyCard(sessionuuid, walletuuid, currencyuuid, _privatekey);
	}

	async _getTokenAccountFromAddress(session, card, tokenaddress) {
		var tokenaccount = await card.getTokenAccountFromAddress(tokenaddress).catch(err => {});

		if (!tokenaccount) {
			var token = card.getTokenObject(tokenaddress);

			if (card.isLocked()) {
				await card.unlock();
			}

			tokenaccount = await card.createTokenAccount(token);
			await tokenaccount.init();

			await tokenaccount._synchronizeWithERC20TokenContract(session); // saves tokenaccount
			
			// var description = 'my quote token account';
			//tokenaccount.setLabel(description);
			//await tokenaccount.save();
		}

		return tokenaccount;
	}

	// TODO: should use mvccurrencies.getCurrencyPosition
	async getCurrencyPosition(sessionuuid, walletuuid, currencyuuid, carduuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);

		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var tokenaddress = currency.address;

		// using token account to get position
/* 		var card = await this._getCurrencyCard(session, wallet, currency).catch(err => {});

		var tokenaccount = await this._getTokenAccountFromAddress(session, card, tokenaddress).catch(err => {});

		const position = (tokenaccount ? await tokenaccount.getPosition().catch(err => {}) : 0);
 */

		// using direct call to ERC20 to speed up result
		var cardinfo ;
		
		if (!carduuid) {
			// main card
			cardinfo = await this.getCurrencyCard(sessionuuid, walletuuid, currencyuuid);
		}
		else {
			var mvcmodule = global.getModuleObject('mvc');
			cardinfo = await mvcmodule. getCardInfo(sessionuuid, walletuuid, carduuid);
		}
		
		
		var cardaddress = cardinfo.address;
		
		// get a childsession on web3providerurl
		//let web3providerurl = await this._getCurrencyWeb3ProviderUrl(session, currency);
		//var childsession = await this._getChildSessionOnWeb3Url(session, web3providerurl);
		var valuescheme = await this._getCurrencyScheme(session, currency);
		var childsession = await this._getMonitoredSchemeSession(session, wallet, valuescheme);

		const position = await _apicontrollers.getAddressERC20Position(childsession, null, tokenaddress, cardaddress)
		.catch((err) => {
			position = 0;
		});

		return this._createCurrencyAmount(childsession, currency, position);
	}

	// TODO: should use mvccurrencies.getCurrencyCardCredits
	async getCurrencyCardCredits(sessionuuid, walletuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);

		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);


		var card = await this._getCurrencyCard(session, wallet, currency);
		var carduuid = card.getCardUUID();
		var schemeuuid = card.getSchemeUUID();

		// TODO: use mvcmodule.getCreditBalance for version >= 0.20.8
		//var credits = await mvcmodule.getCreditBalance(sessionuuid, walletuuid, carduuid);
		var credits = await this.getCreditBalance(sessionuuid, walletuuid, carduuid);

		credits.threshold = await mvcmodule.getSchemeTransactionUnitsThreshold(sessionuuid, schemeuuid);

		return credits;
	}

	async _getMonitoredCardSession(session, wallet, card) {
		var cardsession = card._getSession();

/* 		var scheme = card.getScheme();

		if (scheme.isRemote()) {
			if (wallet) {
				var walletschemeuuid = wallet.getSchemeUUID();
				var schemeuuid = scheme.getSchemeUUID();
	
				if (this._canWalletHandleScheme(wallet, scheme)) {
					// use wallet session
					cardsession = wallet._getSession();
				}
			}
		}
 */
		return cardsession;
	}

	// TODO: should use mvccurrencies.payAmount
	async payAmount(sessionuuid, walletuuid, carduuid, toaddress, currencyuuid, amount) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		
		var card = await wallet.getCardFromUUID(carduuid);
	
		if (!card)
			return Promise.reject('could not find a card for currency ' + currencyuuid);
	
		// we top up card to be sure to be able sending a transaction
		var ops = await this._getCurrencyOps(session, currency);

		if (ops.cantopup === true) {
			const topupinfo = await mvcmodule.topUpCard(sessionuuid, walletuuid, carduuid)		
			.catch(err => {
				console.log('error in payAndReport: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				console.log('no top up for card ' + carduuid);
			}
		}


		// transfer parameters
		var tokenaddress = currency.address;
		var tokenamount = amount;

		
	
		// using token account to make transfer
/* 		
		var tokenaccount = await this._getTokenAccountFromAddress(session, card, tokenaddress).catch(err => {});

		// create contact from toaddress
		var name = toaddress;
		var contactinfo = {};
		var tocontact = await _apicontrollers.createContact(session, name, toaddress, contactinfo).catch(err => {});

		await tokenaccount.transferTo(contact, tokenamount);
 */

		// using direct call to ERC20 to speed up call
		var cardsession = await this._getMonitoredCardSession(session, wallet, card);
		var fromaccount = card._getSessionAccountObject();

		var scheme = await this._getCurrencyScheme(session, currency);

		var providerurl = await this._getCurrencyWeb3ProviderUrl(session, currency);
		var fee  = await _apicontrollers.createSchemeFee(scheme);
		var value = 0;

		const credits = await this.getCreditBalance(sessionuuid, walletuuid, carduuid)
		.catch(err => {
			console.log('error in payAmount: ' + err);
		});

		console.log('sending tokens with gasLimit ' + fee.gaslimit + ' and gas price ' + fee.gasPrice);
		console.log('(fee.gaslimit * fee.gasPrice + value) is ' + (fee.gaslimit * fee.gasPrice + value));
		console.log('transaction credit before transfer is ' + (credits ? credits.transactioncredits : 'unknown'));

		if (credits && (credits.transactioncredits < (fee.gaslimit * fee.gasPrice + value))) {
			console.log('WARNING: transaction credit is lower than (fee.gaslimit * fee.gasPrice + value). You should raise transaction_units_min for corresponding scheme');
		}

/* 		
		var senderprivatekey = fromaccount.getPrivateKey();
		var recipientaddress = toaddress;

		var txhash = await _apicontrollers.sendERC20Tokens(cardsession, providerurl, tokenaddress, senderprivatekey, recipientaddress, tokenamount, fee);

 */		
		// using transferERC20Tokens instead of sendERC20Tokens
		//var ethtx = _apicontrollers.createEthereumTransaction(cardsession, fromaccount);
		var ethtx = await this._createMonitoredEthereumTransaction(wallet, card, cardsession, fromaccount);
			
		ethtx.setToAddress(toaddress);
		ethtx.setGas(fee.gaslimit);
		ethtx.setGasPrice(fee.gasPrice);

		ethtx.setValue(value);

		var txhash = await _apicontrollers.transferERC20Tokens(cardsession, providerurl, tokenaddress, tokenamount, ethtx);

		return txhash;
	}

	// TODO: should use mvccurrencies.payAndReport
	async payAndReport(sessionuuid, walletuuid, toaddress, currencyuuid, amount) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var cardinfo = await this.getCurrencyCard(sessionuuid, walletuuid, currencyuuid);

		if (!cardinfo)
			return Promise.reject('could not find a card for currency ' + currencyuuid);

		var txhash = await this.payAmount(sessionuuid, walletuuid, cardinfo.uuid, toaddress, currencyuuid, amount);

		// we ask provider to make a payment url
		var currency_provider = await this._getCurrencyProvider(session, currency);

		if (!currency_provider)
			return Promise.reject('currency has no provider');

		var paymenturl = currency_provider.getPaymentUrl(txhash);

		return paymenturl;
	}

	async getClaimPayingToAddress(sessionuuid, walletuuid, claim) {
		if (claim.payingto_overload) {
			var global = this.global;
			var _apicontrollers = this._getClientAPI();
		
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);

			var isvalid = _apicontrollers.isValidAddress(session, claim.payingto_overload);

			if (isvalid) {
				claim.payingto = claim.payingto_overload;
			}
		}
		
		return (claim.payingto ? claim.payingto : claim.owner);
	}

	async payClaim(sessionuuid, walletuuid, carduuid, claim) {

		// get currency from the claim
		var toaddress = await this.getClaimPayingToAddress(sessionuuid, walletuuid, claim);
		var currencyuuid = claim.currencyuuid;
		var amount = claim.amount;
		let currencyamount = await this.getCurrencyAmount(sessionuuid, currencyuuid, amount);
		let tokenamount_int = await currencyamount.decimalamount.toInteger();


		var txhash = await this.payAmount(sessionuuid, walletuuid, carduuid, toaddress, currencyuuid, tokenamount_int);

		return txhash;
	}

	_getSchemeNetworkConfig(scheme) {
		var network = scheme.getNetworkConfig();

		return network;
	}



	// TODO: should use mvccurrencies.getCurrencyCardList
	async getCurrencyCardList(sessionuuid, walletuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');

		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var cards = await this._getCurrencyCardList(session, wallet, currency);

		var mvcmodule = global.getModuleObject('mvc');
		var array = [];
				
		for (var i = 0; i < (cards ? cards.length : 0); i++) {
			var carduuid = cards[i].getCardUUID();
			var cardinfo = {uuid: carduuid};
			
			mvcmodule._fillCardInfo(cardinfo, cards[i]);
			
			array.push(cardinfo);
		}
		
		return array;
	}

	// TODO: should use mvccurrencies.getCurencySchemeInfo
	async getCurencySchemeInfo(sessionuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var global = this.global;

		var _apicontrollers = this._getClientAPI();
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var scheme = await this._getCurrencyScheme(session, currency);

		var mvcmodule = global.getModuleObject('mvc');

		var schemeinfo = {uuid: scheme.getSchemeUUID()};
		
		mvcmodule._fillSchemeInfoFromScheme(schemeinfo, scheme);

		return schemeinfo;
	}

	// TODO: should use mvccurrencies.getPretradeSchemeInfo
	async getPretradeSchemeInfo(sessionuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var global = this.global;

		var _apicontrollers = this._getClientAPI();
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		

		var pretradescheme = await this._getPretradeScheme(session, currency);

		var mvcmodule = global.getModuleObject('mvc');

		var pretradeschemeinfo = {uuid: pretradescheme.getSchemeUUID()};
		
		mvcmodule._fillSchemeInfoFromScheme(pretradeschemeinfo, pretradescheme);

		return pretradeschemeinfo;
	}

	// TODO: should use mvccurrencies.getPretradeWeb3Url
	async getPretradeWeb3Url(sessionuuid, currencyuuid) {
		var pretrade_schemeinfo = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);
	
		var pretrade_web3providerurl = pretrade_schemeinfo.network.ethnodeserver.web3_provider_url;

		return pretrade_web3providerurl;
	}

	async _getCardsOnScheme(wallet, scheme, bRefresh = true) {
		var schemeuuid = scheme.getSchemeUUID();
		var cardlist = await wallet.getCardList(bRefresh);

		var array = [];

		for (var i = 0; i < (cardlist ? cardlist.length : 0); i++) {
			var card = cardlist[i];

			if (card.getSchemeUUID() === schemeuuid)
				array.push(card);
		}

		return array;
	}

	// TODO: should use mvccurrencies.getPretradeCard
	async getPretradeCard(sessionuuid, walletuuid, carduuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		
		var card = await wallet.getCardFromUUID(carduuid).catch(err => {});
		
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var pretradecardinfo;

		// for the moment we usually return a card on firenze
		var pretradescheme = await this._getPretradeScheme(session, currency);
		
		var cards = await this._getCardsOnScheme(wallet, pretradescheme, true)
		.catch(err => {
			console.log('error in getPretradeCard: ' + err);
		});

		if (cards) {
			for (var i = 0; i < cards.length; i++) { 
				let pretradecard = cards[i];

				if (pretradecard.isLocked()) {
					await pretradecard.unlock();
				}

				var canPretradeCardSign = await pretradecard.canSign();

				if (canPretradeCardSign === true) {
					pretradecardinfo = await mvcmodule.getCardInfo(sessionuuid, walletuuid, pretradecard.getCardUUID());
					break;
				}				
			}
		}
		
/* 		var pretradeschemeuuid = pretradescheme.getSchemeUUID();
		
		var cardinfos = await mvcmodule.getCardList(sessionuuid, walletuuid, true)
		.catch(err => {
			console.log('error in getPretradeCard: ' + err);
		});

		if (cardinfos) {
			for (var i = 0; i < cardinfos.length; i++) {

				if (pretradeschemeuuid === cardinfos[i].schemeuuid) {
					// check card can sign
					let pretradecard = await wallet.getCardFromUUID(cardinfos[i].uuid).catch(err => {});

					if (pretradecard) {			
						if (pretradecard.isLocked()) {
							await pretradecard.unlock();
						}

						var canPretradeCardSign = await pretradecard.canSign();

						if (canPretradeCardSign === true) {
							pretradecardinfo = cardinfos[i];
							break;
						}
					}
				}
			}
		} */

		

		if (!pretradecardinfo) {
			if (card.isLocked()) {
				await card.unlock();
			}
						
			let canCardSign = await card.canSign();
			let pretradecard;

			if (canCardSign === true) {
				var pretrade_schemeinfo = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);

				if (pretrade_schemeinfo.uuid != card.getSchemeUUID()) {
					// we clone card on pretrade scheme
					pretradecardinfo = await mvcmodule.cloneCard(sessionuuid, walletuuid, carduuid, pretrade_schemeinfo.uuid);
				}
				else {
					// we return the card it self
					pretradecardinfo = await mvcmodule.getCardInfo(sessionuuid, walletuuid, carduuid);
				}

				if (!pretradecardinfo)
					return Promise.reject('could not clone or pick the main card for pretrade use');

				pretradecard = await wallet.getCardFromUUID(pretradecardinfo.uuid);
			}
			else {
				// main card is read-only, we can not use a clone or the card itself
				//return Promise.reject('card is read-only, can not create corresponding pretrade card');

				// let's create a card on the fly
				var _privatekey = _apicontrollers.generatePrivateKey(session);

				pretradecard = await _apicontrollers.createWalletCard(session, wallet, pretradescheme, _privatekey);

				if (!pretradecard)
					return Promise.reject('could not generate a pretrade card');

			}

			if (!pretradecard)
				return Promise.reject('could not create a pretrade card');

			// mark as pretrade card
			await this.setPretradeCard(sessionuuid, walletuuid, currencyuuid, pretradecard.uuid);

			pretradecardinfo = await mvcmodule.getCardInfo(sessionuuid, walletuuid, pretradecard.uuid);

		}

		if (!pretradecardinfo)
			return Promise.reject('could not find a card to register transactions');

		return pretradecardinfo;
	}


	// TODO: should use mvccurrencies.setPretradeCard
	async setPretradeCard(sessionuuid, walletuuid, currencyuuid, carduuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);

		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var card = await wallet.getCardFromUUID(carduuid);
	
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		// sift through cards for currency to set the pretradecard flag accordingly
		var pretradescheme = await this._getPretradeScheme(session, currency);
		
		var cards = await this._getCardsOnScheme(wallet, pretradescheme, true)
		.catch(err => {
			console.log('error in getPretradeCard: ' + err);
		});

		if (cards) {
			for (var i = 0; i < (cards ? cards.length : 0); i++) {
				let card = cards[i];
				let xtradata = card.getXtraData('myquote');
	
				if (xtradata && (xtradata.pretradecard === true)) {
					// remove flag
					xtradata.pretradecard = false;
	
					card.putXtraData('myquote', xtradata);
	
					if (card.isLocked()) {
						await card.unlock();
					}
			
					await card.save();
				}
	
				if (card.getCardUUID() === carduuid) {
					xtradata = (xtradata ? xtradata : {});
					xtradata.pretradecard = true;
	
					card.putXtraData('myquote', xtradata);
	
					if (card.isLocked()) {
						await card.unlock();
					}
	
					await card.save();
				}
	
			}
		}
	
	}

	//
	// Transaction functions
	//

	// Note: 
	// fetch, register and update are for blockchain persistence
	// read, save and modify are for storage persistence


	async registerTransaction(sessionuuid, walletuuid, carduuid, dataobj, assignto) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		
		var card = await wallet.getCardFromUUID(carduuid);
		
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		let cardsession = await this._getMonitoredCardSession(session, wallet, card);
		let cardsessionuuid = cardsession.getSessionUUID();

		var _tohex= (data) => {
			let datastr = JSON.stringify(dataobj);
			let buf = Buffer.from(datastr, 'utf8');
			return '0x' + buf.toString('hex');
		}

		var datahexstring = _tohex(dataobj);
		var fromaccount = card._getSessionAccountObject();
		var toaddress = (assignto ? assignto : fromaccount.getAddress());
		
		//var transaction = _apicontrollers.createEthereumTransaction(cardsession, fromaccount);
		var transaction = await this._createMonitoredEthereumTransaction(wallet, card, cardsession, fromaccount);
		
		var fee = _apicontrollers.createFee();
		
		transaction.setToAddress(toaddress);
		transaction.setValue(0);
		transaction.setGas(fee.gaslimit);
		transaction.setGasPrice(fee.gasPrice);
		
		transaction.setData(datahexstring);
		
		const txhash = await _apicontrollers.sendEthereumTransaction(cardsession, transaction)
		.catch((err) => {
			console.log('error in registerTransaction: ' + err);
		});

		if (!txhash)
		return Promise.reject('could not register transaction');

		// save
		dataobj.txhash = txhash; // add transaction hash to save it, blocknumber will be added later

		// using sessionuuid to save locally (in 'shared') on the client side
		await this._saveTransactionObject(sessionuuid, walletuuid, dataobj);

		return txhash;
	}

	_fillTransactionDataObject(dataobject, tx) {
		var dataobj = {};

		if (!tx)
			return dataobject;
		
		try {
			dataobj = JSON.parse(tx.input_decoded_utf8);
		}
		catch(e) {
			// another type of transaction
			dataobj = {};
		}

		dataobj.blocknumber = tx.block.blocknumber;
		dataobj.blocktime = tx.block.timestamp;
		dataobj.txhash = tx.hash;

		dataobject = Object.assign(dataobject, dataobj);

		return dataobject;
	}

	// TODO: should use mvccurrencies._getMonitoredSchemeSession
	async _getMonitoredSchemeSession(session, wallet, scheme) {
		var fetchsession;

		if (!scheme)
			return Promise.reject('scheme is not defined');

		if (scheme.isRemote()) {
			if (wallet) {
				var walletschemeuuid = wallet.getSchemeUUID();
				var schemeuuid = scheme.getSchemeUUID();
	
				if (this._canWalletHandleScheme(wallet, scheme)) {
					// use wallet session
					fetchsession = wallet._getSession();
				}
				else {
					return Promise.reject('ERR_MISSING_CREDENTIALS');
				}
			}
			else {
				return Promise.reject('ERR_MISSING_CREDENTIALS');
			}
		}
		else {
			if (wallet) {
				var walletsession = wallet._getSession();
				fetchsession = await this._getChildSessionOnScheme(walletsession, scheme);
			}
			else {
				fetchsession = await this._getChildSessionOnScheme(session, scheme);
			}
		}

		return fetchsession;
	}


	async _fetchTransaction(session, wallet, pretradescheme, txhash, bPersist = false) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var fetchsession = await this._getMonitoredSchemeSession(session, wallet, pretradescheme);
		var fetchsessionuuid = fetchsession.getSessionUUID();

		const tx = await _apicontrollers.readTransaction(fetchsession, txhash)
		.catch((err) => {
			console.log('error in _fetchTransaction: ' + err);
		});

		if (!tx)
			return Promise.reject('could not find transaction ' + txhash);
		
		var dataobj = {};
		
		this._fillTransactionDataObject(dataobj, tx);

		if (bPersist) {
			var sessionuuid = session.getSessionUUID();
			let walletuuid = (wallet ? wallet.getWalletUUID() : null);

			let persistdata = Object.assign({}, dataobj);

			persistdata.txhash = txhash;

			// using sessionuuid to save locally (in 'shared') on the client side
			await this._saveTransactionObject(sessionuuid, walletuuid, persistdata);
		}

		return dataobj;
	}

	async fetchTransaction(sessionuuid, walletuuid, pretradeschemeuuid, txhash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!pretradeschemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		// get a session on web3providerurl
		let wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid)
		.catch(err => {});

		let pretradescheme = await _apicontrollers.getSchemeFromUUID(session, pretradeschemeuuid)
		.catch(err => {});

		if (pretradescheme.isRemote()) {
			// check wallet is not locked
			// TODO: can use wallet.checkLock for version >= 0.20.8
			if (wallet && wallet.isLocked())
				return Promise.reject('ERR_WALLET_LOCKED');
		}

		return this._fetchTransaction(session, wallet, pretradescheme, txhash, true);
	}

	async fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, txhash) {
		var pretradescheme_info = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);

		return this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, txhash);
	}

/* 	async fetchWalletCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, txhash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		
		// get a childsession on currency pretrade web3provider
		var pretradeweb3rurl = await this.getPretradeWeb3Url(sessionuuid, currencyuuid);
		var childsession = await this._getChildSessionOnWeb3Url(session, pretradeweb3rurl);

		return this._fetchTransaction(childsession, wallet, txhash, true);
	} */

	async _getAddressPretradeTransactions(session, wallet, currency, address) {
		var global = this.global;
		var mytokensmodule = global.getModuleObject('mytokens');

		// get a childsession on pretrade's web3providerurl
		//let web3providerurl = currency.pretrade_web3_provider_url;
		//var childsession = await this._getChildSessionOnWeb3Url(session, web3providerurl);
		var pretradescheme = await this._getPretradeScheme(session, currency);
		var childsession = await this._getMonitoredSchemeSession(session, wallet, pretradescheme);

		var currencyuuid = currency.uuid;

		var mytokensaccessinstance = childsession.getSessionVariable('mytokensexplorer-' + currencyuuid);

		if (!mytokensaccessinstance) {
			// create a specific mytokens instance pointing to pretrade_explorer_url to retrieve transactions
			mytokensaccessinstance = mytokensmodule.getMyTokensServerAccessInstance(childsession);

			var restconnection = childsession.createRestConnection(currency.pretrade_explorer_url);

			mytokensaccessinstance.setRestConnection(restconnection);

			childsession.setSessionVariable('mytokensexplorer-' + currencyuuid, mytokensaccessinstance);
		}

		var transactions = await mytokensaccessinstance.account_transactions(address);

		// fake ethchainreader
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
		var ethereumnodeaccessinstance = ethereumnodeaccessmodule.getEthereumNodeAccessInstance(childsession)

		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			try {
				// see if input can be decoded in utf8
				tx.input_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(childsession, tx.input);
			}
			catch(e) {
			}
			tx.block = (tx.block ? tx.block : {});
			tx.block.blocknumber = tx.blockNumber;
			tx.block.timestamp = tx.timeStamp;
		}

		return transactions;
	}


	async canFetchTransactions(sessionuuid, walletuuid, currencyuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var pretradescheme = await this._getPretradeScheme(session, currency);
		var fetchsession = await this._getMonitoredSchemeSession(session, wallet, pretradescheme).catch(err=> {});

		if (!fetchsession)
			return false;
		
		if (currency.pretrade_explorer_url)
			return true;
		else
			return false;
	}

	async fetchTransactions(sessionuuid, walletuuid, currencyuuid, address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);


		// use explorer to fetch transactions for address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, address);

		// we filter quotes
		var txlist = {};

		txlist.bounties = [];
		txlist.claims = [];

		txlist.quotes = [];
		txlist.orders = [];
		txlist.invoices = [];
		txlist.paymentnotices = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			switch(dataobject.type == 'quote') {
				case 'bounty':
					txlist.bounties.push(dataobject);
					break;
				case 'claim':
					txlist.claims.push(dataobject);
					break;
				case 'quote':
					txlist.quotes.push(dataobject);
					break;
				case 'order':
					txlist.orders.push(dataobject);
					break;
				case 'invoice':
					txlist.invoices.push(dataobject);
					break;
				case 'paymentnotice':
					txlist.paymentnotices.push(dataobject);
					break;
			
				default:
					break;
			}
		}

		return txlist;
	}

	//
	// Bounties
	//

	async readBounties(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!walletuuid) {
			var keys = ['myquote', 'bounties']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'bounties']; 
			// shared keys, also we could look in wallet
			// with mvcmodule.getFromWallet
		}
	
		//let bounty_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		let bounty_list = await this._readClientSideJson(session, keys);

		if (!bounty_list)
			bounty_list = [];

		return bounty_list;
	}

	async fetchBounties(sessionuuid, walletuuid, currencyuuid, vendor_address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);


		// use explorer to fetch transactions for vendor's address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, vendor_address);

		// we filter bounties
		var bountylist = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			if ((dataobject.type == 'bounty') && (dataobject.owner == vendor_address)) {
				//await this.saveBounty(sessionuuid, null, dataobject);

				bountylist.push(dataobject);
			}
		}

		return bountylist;
	}

	async fetchBounty(sessionuuid, walletuuid, currencyuuid, txhash) {

		var missing_credentials = false;
		var orgbounty = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in fetchBounty: ' + err);

			if (err == 'ERR_MISSING_CREDENTIALS')
				missing_credentials = true;
		});

		if (missing_credentials === true)
			return Promise.reject('ERR_MISSING_CREDENTIALS');

		if (!orgbounty)
			return Promise.reject('ERR_BOUNTY_NOT_FOUND');

		// we post-process the bounty record
		var bounty = {};

		// copy the record
		Object.assign(bounty, orgbounty);

		if (!orgbounty.ver) {
			// version 1
			bounty.one_submission = false;
		}
		else if (orgbounty.ver == "2") {
			var submission_options = orgbounty.submission_options;

			bounty.private_submission = (submission_options & 1 ? true : false);
			bounty.one_submission = (submission_options & 2 ? true : false);
		}
		else {
			console.log('error: bounty on chain has wrong version number ' + orgbounty.ver);
		}

		return bounty;
	}
	
	async registerBounty(sessionuuid, walletuuid, carduuid, bounty) {
		// we pre-process the bounty before pushing it to the chain
		var _bounty = {};

		// copy the record
		Object.assign(_bounty, bounty);

		// put version
		_bounty.ver = "2";

		// remove boolean flags
		delete _bounty.private_submission;
		delete _bounty.one_submission;

		// compute submission_options and add it to _bounty
		_bounty.submission_options = 0;
		if (bounty.private_submission) _bounty.submission_options += 1;
		if (bounty.one_submission) _bounty.submission_options += 2;

		// in ver="2" we assign to bounty card to minimize transaction list to be retrieved
		var assignto = bounty.bounty_card_address; 

		var txhash = await this.registerTransaction(sessionuuid, walletuuid, carduuid, _bounty, assignto);

		return txhash;
	}

	async saveBounty(sessionuuid, walletuuid, bounty) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var bounty_list = await this.readBounties(sessionuuid, walletuuid);

		// look not in list
		var bInList = false;

		for (var i = 0; i < bounty_list.length; i++) {
			if (bounty_list[i].txhash == bounty.txhash) {
				bInList = true;
				break;
			}
		}

		if (!bInList) {
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);

			// bounty parameters to be saved
			var {txhash, blocknumber, currencyuuid, owner, title, amount, currency} = bounty;
	
			if (!walletuuid) {
				var keys = ['myquote', 'bounties']; 
				// shared keys
			}
			else {
				console.log('WARNING: walletuuid specific case not implemented!!!');
				var keys = ['myquote', 'bounties']; 
				// shared keys, also we could put in wallet
				// with mvcmodule.putInWallet			
			}
		
			var localjson = {txhash, blocknumber, currencyuuid, owner, title, amount, currency};

			localjson.savetime = Date.now();

			bounty_list.push(localjson);
	
			//return _apicontrollers.saveLocalJson(session, keys, bounty_list);
			return this._saveClientSideJson(session, keys, bounty_list);
		}
		else {
			return bounty_list;
		}
	}

	// chain persistence
	_getBountyAssignAddress(session, bounty) {
		var assign_address;

		if (!bounty.ver)
			assign_address = bounty.owner;
		if (bounty.ver == "2")
			assign_address = bounty.bounty_card_address; // bounty card has less transactions

		return assign_address;
	}

	async fetchClaims(sessionuuid, walletuuid, currencyuuid, bountyhash) {

		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});

		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);
	
		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);
	
		// read quote
		var bounty = await this.fetchBounty(sessionuuid, walletuuid, currencyuuid, bountyhash);
		var assign_address = this._getBountyAssignAddress(session, bounty);
	
		// use explorer to fetch transactions for address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, assign_address);
	
		// we filter claims
		var claimmap = {};
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];
	
			var dataobject = {};
	
			this._fillTransactionDataObject(dataobject, tx);
	
			if ((dataobject.type == 'claim') && (dataobject.bounty == bountyhash)) {

				if (!dataobject.uuid) {
					// add an uuid now
					dataobject.uuid = session.guid();
					await this.saveClaim(sessionuuid, null, dataobject);
				}

				if (claimmap[dataobject.uuid]) {
					// keep the latest (full copy persistence)
					let latest = claimmap[dataobject.uuid].latest;

					if (dataobject.blocknumber > latest.blocknumber) {
						claimmap[dataobject.uuid].latest = dataobject;
					}
					else if ((dataobject.blocknumber == latest.blocknumber) && (dataobject.ordId > (latest.ordId ? latest.ordId : 0))) {
						claimmap[dataobject.uuid].latest = dataobject;
					}

					// update if first come afterward in list
					let first = claimmap[dataobject.uuid].latest;

					if (dataobject.blocknumber < first.blocknumber) {
						claimmap[dataobject.uuid].first = dataobject;
					}
					else if ((dataobject.blocknumber == latest.blocknumber) && ((dataobject.ordId ? dataobject.ordId : 0) < (first.ordId ? first.ordId : 0))) {
						claimmap[dataobject.uuid].first = dataobject;
					}
				}
				else {
					//claimmap[dataobject.uuid] = dataobject;
					claimmap[dataobject.uuid] = {first: dataobject, latest: dataobject};
				}
			}
		}

		var claimlist = [];
		
		var arr = Object.values(claimmap);

		for (var i = 0; i < (arr ? arr.length : 0); i++) {
			let entry = Object.assign({}, arr[i].latest);
			
			entry.update_blocktime = entry.blocktime;
			entry.update_blocknumber = entry.blocknumber;
			entry.blocktime = arr[i].first.blocktime;
			entry.blocknumber = arr[i].first.blocknumber;
			
			claimlist.push(entry);
		}
	
		return claimlist;
	}

	async fetchClaim(sessionuuid, walletuuid, currencyuuid, txhash) {

		var missing_credentials = false;
		var orgclaim = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in fetchClaim: ' + err);

			if (err == 'ERR_MISSING_CREDENTIALS')
				missing_credentials = true;
		});

		if (missing_credentials === true)
			return Promise.reject('ERR_MISSING_CREDENTIALS');

		if (!orgclaim)
			return Promise.reject('ERR_CLAIM_NOT_FOUND');

		if (!orgclaim.uuid)
			return Promise.reject('claim was not registered with a proper uuid ' + txhash);

		// we scan the claims to see if the original claim has been updated
		// with new record
		var claim = orgclaim;
		var claims = await this.fetchClaims(sessionuuid, walletuuid, currencyuuid, claim.bounty);

		for (var i = 0; i < (claims ? claims.length : 0); i++) {
			var clm = claims[i];
	
			if (clm.uuid === orgclaim.uuid) {
				claim = claims[i];
				break;
			}
		}

		return claim;
	}

	async canRegisterClaim(sessionuuid, walletuuid, carduuid, claim) {
		let bounty = await this.fetchBounty(sessionuuid, walletuuid, claim.currencyuuid, claim.bounty);

		if (bounty.one_submission === true) {
			// we get list of claims already submitted and see if claim.owner or claim.payingto
			// have already been registered
			var claims = await this.fetchClaims(sessionuuid, bounty.currencyuuid, bounty.txhash);

			var owner_map = {};
			var payingto_map = {};

			for (var i = 0; i < (claims ? claims.length : 0); i++) {
				var clm = claims[i];
		
				if (clm.owner) owner_map[clm.owner] = clm.owner;
				if (clm.payingto) payingto_map[clm.payingto] = clm.payingto;
			}

			if (owner_map[claim.owner])
				return false;

			if (claim.payingto && payingto_map[claim.payingto])
				return false;
		}

		return true;
	}
	
	async registerClaim(sessionuuid, walletuuid, carduuid, claim) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		if (!carduuid)
			return Promise.reject('card uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

	
		var card = await wallet.getCardFromUUID(carduuid);
		
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		let cardsession = await this._getMonitoredCardSession(session, wallet, card);

		// we add an uuid to the claim that will live in multiple txhash
		var claimuuid = cardsession.guid();

		claim.uuid = claimuuid;

		let bounty = await this.fetchBounty(sessionuuid, walletuuid, claim.currencyuuid, claim.bounty);
		var assign_address = this._getBountyAssignAddress(session, bounty);

		var txhash = await this.registerTransaction(sessionuuid, walletuuid, carduuid, claim, assign_address);

		return txhash;
	}

	async updateClaim(sessionuuid, walletuuid, carduuid, claim) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
			return Promise.reject('wallet uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
	
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);

		let bounty = await this.fetchBounty(sessionuuid, walletuuid, claim.currencyuuid, claim.bounty);
		var assign_address = this._getBountyAssignAddress(session, bounty);

		
		if (!claim.uuid)
			return Promise.reject('claim has no uuid ' + claim.txhash);
		
		// we work with a full copy registration (newer is the correct record) and not difference (adding modifications)
		var txhash = await this.registerTransaction(sessionuuid, walletuuid, carduuid, claim, assign_address);

		if (txhash) {
			await this.saveClaim(sessionuuid, walletuuid, claim); // note: we have not implemented a modifyClaim function
		}

		return txhash;
	}

	// storage
	async _readClaims(session, keys) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		//var claim_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		var claim_list = await this._readClientSideJson(session, keys);
	
		if (!claim_list)
		claim_list = [];

		return claim_list;
	}

	async readClaims(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
	
		if (!walletuuid) {
			var keys = ['myquote', 'claims']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'claims']; 
			// shared keys, otherwise we could look in wallet
			// with mvcmodule.getFromWallet
		}
		
		var claim_list = await this._readClaims(session, keys);

		// we go through the list to see if some 'unhandled yet' claims
		// need to be checked
		var unhandled_claims = [];

		for (var i = 0; i < claim_list.length; i++) {
			if (claim_list[i].status === 0)
				unhandled_claims.push(claim_list[i]);
		}

		// then fetch for each claim (could be speeded up if necessary)
		for (var i = 0; i < unhandled_claims.length; i++) {
			var claim = await this.fetchClaim(sessionuuid, walletuuid, unhandled_claims[i].currencyuuid, unhandled_claims[i].txhash).catch(err => {});

			if (claim && (claim.status !== 0)) {
				await this.saveClaim(sessionuuid, walletuuid, claim);
			}
		}
	
		return claim_list;
	}
	
	async saveClaim(sessionuuid, walletuuid, claim) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var keys;

		if (!walletuuid) {
			keys = ['myquote', 'claims']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			keys = ['myquote', 'claims']; 
			// shared keys, also we could put in wallet
			// with mvcmodule.putInWallet
		}		
			
		var claim_list = await this._readClaims(session, keys);
	
		var bInList = false;
		var claim_index;
	
		for (var i = 0; i < claim_list.length; i++) {
			if (claim.txhash && (claim_list[i].txhash == claim.txhash)) {
				bInList = true;
				claim_index = i;
				break;
			}

			// using uuid now to identify claims because of multiple txhash for same entity
			if (claim.uuid && (claim_list[i].uuid == claim.uuid)) {
				bInList = true;
				claim_index = i;
				break;
			}

		}
	
		if (!bInList) {
			// add new element to the list
	
			// claim parameters
			let {uuid, txhash, blocknumber, currencyuuid, owner, bounty, amount, currency, private_submission, answer, status} = claim;
	
			// read bounty to get title
			var pretradescheme_info = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);
	
			let bountyobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, bounty)
			.catch(err => {});
			
			let title = (bountyobject ? bountyobject.title : null);
	
			let localjson = {uuid, txhash, blocknumber, currencyuuid, owner, bounty, title, amount, currency, private_submission, answer, status};
	
			localjson.savetime = Date.now();
	
			claim_list.push(localjson);
		}
		else {
			// we update claim at correct index (transfering additional parameters)
			let title = claim_list[claim_index].title;
			let savetime = claim_list[claim_index].savetime;

			claim_list[claim_index] = claim;

			claim_list[claim_index].title = title;
			claim_list[claim_index].savetime = savetime;
		}

		//return _apicontrollers.saveLocalJson(session, keys, claim_list);
		return this._saveClientSideJson(session, keys, claim_list);
	}	

	//
	// Quotes
	//

	async readQuotes(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!walletuuid) {
			var keys = ['myquote', 'quotes']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'quotes']; 
			// shared keys, also we could look in wallet
			// with mvcmodule.getFromWallet
		}
	
		//let quote_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		let quote_list = await this._readClientSideJson(session, keys);

		if (!quote_list)
			quote_list = [];

		return quote_list;
	}

	async fetchQuotes(sessionuuid, walletuuid, currencyuuid, vendor_address) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);


		// use explorer to fetch transactions for vendor's address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, vendor_address);

		// we filter quotes
		var quotelist = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			if ((dataobject.type == 'quote') && (dataobject.owner == vendor_address)) {
				//await this.saveQuote(sessionuuid, null, dataobject);

				quotelist.push(dataobject);
			}
		}

		return quotelist;
	}

	async saveQuote(sessionuuid, walletuuid, quote) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var quote_list = await this.readQuotes(sessionuuid, walletuuid);

		// look not in list
		var bInList = false;

		for (var i = 0; i < quote_list.length; i++) {
			if (quote_list[i].txhash == quote.txhash) {
				bInList = true;
				break;
			}
		}

		if (!bInList) {
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);

			// quote parameters to be saved
			var {txhash, blocknumber, currencyuuid, owner, title, amount, currency} = quote;
	
			if (!walletuuid) {
				var keys = ['myquote', 'quotes']; 
				// shared keys
			}
			else {
				console.log('WARNING: walletuuid specific case not implemented!!!');
				var keys = ['myquote', 'quotes']; 
				// shared keys, also we could put in wallet
				// with mvcmodule.putInWallet			
			}
		
			var localjson = {txhash, blocknumber, currencyuuid, owner, title, amount, currency};

			localjson.savetime = Date.now();

			quote_list.push(localjson);
	
			//return _apicontrollers.saveLocalJson(session, keys, quote_list);
			return this._saveClientSideJson(session, keys, quote_list);
		}
		else {
			return quote_list;
		}
	}

	async readOrders(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!walletuuid) {
			var keys = ['myquote', 'orders']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'orders']; 
			// shared keys, otherwise we could look in wallet
			// with mvcmodule.getFromWallet
		}
		
		//let order_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		let order_list = await this._readClientSideJson(session, keys);

		if (!order_list)
		order_list = [];

		return order_list;
	}

	async fetchOrders(sessionuuid, walletuuid, currencyuuid, quotehash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);

		// read quote
		var quote = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, quotehash);
		var vendor_address = quote.owner;

		// use explorer to fetch transactions for vendor's address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, vendor_address);

		// we filter orders
		var orderlist = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			if ((dataobject.type == 'order') && (dataobject.quote == quotehash)) {
				//await this.saveOrder(sessionuuid, null, dataobject);

				orderlist.push(dataobject);
			}
		}

		return orderlist;
	}

	async scanNextBlockForOrders(sessionuuid, walletuuid, currencyuuid, quotehash, blockshift) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		
		var keys = ['myquote', 'scan', 'orders', quotehash]; 

		//let scan = await _apicontrollers.getLocalJsonLeaf(session, keys);
		let scan = await this._readClientSideJson(session, keys);

		if (!scan)
			scan = {};
			
		var quote = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, quotehash);
		var new_orders = [];

		// get a childsession on currency pretrade web3provider
		var pretradeweb3rurl = await this.getPretradeWeb3Url(sessionuuid, currencyuuid);
		var childsession = await this._getChildSessionOnWeb3Url(session, pretradeweb3rurl);

		// scan
		const current_blocknumber = await _apicontrollers.readCurrentBlockNumber(childsession)

		var start_block_number = (scan.last_block_number ? scan.last_block_number : quote.blocknumber) + 1;
		var last_block_number = (start_block_number + blockshift <  current_blocknumber ? start_block_number + blockshift : current_blocknumber );

		var ordernum = (scan.ordernum ? scan.ordernum : 0);

		// read transactions for each block
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
		var ethereumnodeaccessinstance = ethereumnodeaccessmodule.getEthereumNodeAccessInstance(childsession)

		for (var blocknumber = start_block_number; blocknumber < last_block_number + 1; blocknumber++) {
			//console.log('reading block ' + blocknumber);
			//var transactions = await _apicontrollers.readBlockTransactions(childsession, blocknumber);
 			var block = await new Promise((resolve, reject) => {
				ethereumnodeaccessinstance.web3_getBlock(blocknumber, true,  (err, res) => {if (err) reject(err); else resolve(res);});
			})
			.catch(err => {
				console.log('error in scanNextBlockForOrders: ' + err);
			});
			var transactions = block.transactions;
 
			for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
				var tx = transactions[i];

				// fake ethchainreader
				tx.input_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(childsession, tx.input);
				tx.block = {}
				tx.block.blocknumber = tx.blockNumber;
				tx.block.timestamp = tx.timeStamp;

				var dataobject = {};

				this._fillTransactionDataObject(dataobject, tx);

				console.log('found one transaction at ' + blocknumber);

				if (dataobject.type == 'order') {
					await this.saveOrder(sessionuuid, null, dataobject);

					new_orders.push(dataobject);

					ordernum++
				}
			}
		}

		// save where we are
		scan.last_block_number = last_block_number;
		scan.ordernum = ordernum;

		//await _apicontrollers.saveLocalJson(session, keys, scan);
		await this._saveClientSideJson(session, keys, scan);

		return new_orders;
	}

	async saveOrder(sessionuuid, walletuuid, order) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();


		var order_list = await this.readOrders(sessionuuid, walletuuid);

		var bInList = false;

		for (var i = 0; i < order_list.length; i++) {
			if (order_list[i].txhash == order.txhash) {
				bInList = true;
				break;
			}
		}

		if (!bInList) {
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);
	
			// order parameters
			let {txhash, blocknumber, currencyuuid, owner, quote, amount, currency, hadfunds} = order;

			// read quote to get title
			var pretradescheme_info = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);

			let quoteobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, quote)
			.catch(err => {});
			
			let title = (quoteobject ? quoteobject.title : null);
			
			if (!walletuuid) {
				var keys = ['myquote', 'orders']; 
				// shared keys
			}
			else {
				console.log('WARNING: walletuuid specific case not implemented!!!');
				var keys = ['myquote', 'orders']; 
				// shared keys, also we could put in wallet
				// with mvcmodule.putInWallet
			}
	
			let localjson = {txhash, blocknumber, currencyuuid, owner, quote, title, amount, currency, hadfunds};

			localjson.savetime = Date.now();

			order_list.push(localjson);

			//return _apicontrollers.saveLocalJson(session, keys, order_list);
			return this._saveClientSideJson(session, keys, order_list);
		}
		else {
			return order_list;
		}
	}

	async readInvoices(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!walletuuid) {
			var keys = ['myquote', 'invoices']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'invoices']; 
			// shared keys, otherwise we could look in wallet
			// with mvcmodule.getFromWallet
		}
		
		//let invoice_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		let invoice_list = await this._readClientSideJson(session, keys);

		if (!invoice_list)
		invoice_list = [];

		return invoice_list;
	}

	async fetchInvoices(sessionuuid, walletuuid, currencyuuid, orderhash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);

		// read order
		var order = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, orderhash);
		var buyer_address = order.owner;

		// use explorer to fetch transactions for buyer's address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, buyer_address);

		// we filter invoices
		var invoicelist = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			if ((dataobject.type == 'invoice') && (dataobject.order == orderhash)) {
				//await this.saveInvoice(sessionuuid, null, dataobject);

				invoicelist.push(dataobject);
			}
		}

		return invoicelist;
	}

	async saveInvoice(sessionuuid, walletuuid, invoice) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();


		var invoice_list = await this.readInvoices(sessionuuid, walletuuid);

		var bInList = false;

		for (var i = 0; i < invoice_list.length; i++) {
			if (invoice_list[i].txhash == invoice.txhash) {
				bInList = true;
				break;
			}
		}

		if (!bInList) {
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);
	
			// invoice parameters
			let {txhash, blocknumber, currencyuuid, owner, order, amount, currency} = invoice;

			// read order and quote to get title
			var pretradescheme_info = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);

			let orderobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, order)
			.catch(err => {});

			let quoteobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, orderobject.quote)
			.catch(err => {});
			
			let title = (quoteobject ? quoteobject.title : null);
			
			if (!walletuuid) {
				var keys = ['myquote', 'invoices']; 
				// shared keys
			}
			else {
				console.log('WARNING: walletuuid specific case not implemented!!!');
				var keys = ['myquote', 'invoices']; 
				// shared keys, also we could put in wallet
				// with mvcmodule.putInWallet
			}
	
			let localjson = {txhash, blocknumber, currencyuuid, owner, order, title, amount, currency};

			localjson.savetime = Date.now();

			invoice_list.push(localjson);

			//return _apicontrollers.saveLocalJson(session, keys, invoice_list);
			return this._saveClientSideJson(session, keys, invoice_list);
		}
		else {
			return invoice_list;
		}
	}
	
	async readPaymentNotices(sessionuuid, walletuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		if (!walletuuid) {
			var keys = ['myquote', 'paymentnotices']; 
			// shared keys
		}
		else {
			console.log('WARNING: walletuuid specific case not implemented!!!');
			var keys = ['myquote', 'paymentnotices']; 
			// shared keys, otherwise we could look in wallet
			// with mvcmodule.getFromWallet
		}
		
		//let paymentnotice_list = await _apicontrollers.getLocalJsonLeaf(session, keys, true);
		let paymentnotice_list = await this._readClientSideJson(session, keys);

		if (!paymentnotice_list)
		paymentnotice_list = [];

		return paymentnotice_list;
	}

	async fetchPaymentNotices(sessionuuid, walletuuid, currencyuuid, invoicehash) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid).catch(err => {});
			
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
	
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		if (!currency.pretrade_explorer_url)
			return Promise.reject('no explorer for currency ' + currencyuuid);

		// read invoice
		var invoice = await this.fetchCurrencyTransaction(sessionuuid, walletuuid, currencyuuid, invoicehash);
		var vendor_address = invoice.owner;

		// use explorer to fetch transactions for vendor's address
		var transactions = await this._getAddressPretradeTransactions(session, wallet, currency, vendor_address);

		// we filter payment notices
		var paymentnoticelist = [];
		
		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var tx = transactions[i];

			var dataobject = {};

			this._fillTransactionDataObject(dataobject, tx);

			if ((dataobject.type == 'paymentnotice') && (dataobject.invoice == invoicehash)) {
				//await this.savePaymentNotice(sessionuuid, null, dataobject);

				paymentnoticelist.push(dataobject);
			}
		}

		return paymentnoticelist;
	}

	async savePaymentNotice(sessionuuid, walletuuid, paymentnotice) {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();


		var paymentnotice_list = await this.readPaymentNotices(sessionuuid, walletuuid);

		var bInList = false;

		for (var i = 0; i < paymentnotice_list.length; i++) {
			if (paymentnotice_list[i].txhash == paymentnotice.txhash) {
				bInList = true;
				break;
			}
		}

		if (!bInList) {
			var session = await _apicontrollers.getSessionObject(sessionuuid);
		
			if (!session)
				return Promise.reject('could not find session ' + sessionuuid);
	
			// paymentnotice parameters
			let {txhash, blocknumber, currencyuuid, owner, invoice, amount, currency} = paymentnotice;

			// read invoice, order and quote to get title
			var pretradescheme_info = await this.getPretradeSchemeInfo(sessionuuid, currencyuuid);

			let invoiceobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, invoice)
			.catch(err => {});

			let orderobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, invoiceobject.order)
			.catch(err => {});

			let quoteobject = await this.fetchTransaction(sessionuuid, walletuuid, pretradescheme_info.uuid, orderobject.quote)
			.catch(err => {});
			
			let title = (quoteobject ? quoteobject.title : null);
			
			if (!walletuuid) {
				var keys = ['myquote', 'paymentnotices']; 
				// shared keys
			}
			else {
				console.log('WARNING: walletuuid specific case not implemented!!!');
				var keys = ['myquote', 'paymentnotices']; 
				// shared keys, also we could put in wallet
				// with mvcmodule.putInWallet
			}
	
			let localjson = {txhash, blocknumber, currencyuuid, owner, invoice, title, amount, currency};

			localjson.savetime = Date.now();

			paymentnotice_list.push(localjson);

			//return _apicontrollers.saveLocalJson(session, keys, paymentnotice_list);
			return this._saveClientSideJson(session, keys, paymentnotice_list);
		}
		else {
			return paymentnotice_list;
		}
	}
	
	async _saveTransactionObject(sessionuuid, walletuuid, tx) {
		if (!tx)
			return;

		switch (tx.type) {
			case 'bounty':
				return this.saveBounty(sessionuuid, walletuuid, tx);

			case 'claim':
				return this.saveClaim(sessionuuid, walletuuid, tx);

			case 'quote':
				return this.saveQuote(sessionuuid, walletuuid, tx);

			case 'order':
				return this.saveOrder(sessionuuid, walletuuid, tx);

			case 'invoice':
				return this.saveInvoice(sessionuuid, walletuuid, tx);

			case 'paymentnotice':
				return this.savePaymentNotice(sessionuuid, walletuuid, tx);

			default:
				break;
		}
	}

	//
	// uniswap
	//

	// TODO: should use mvccurrencies.getPriceForCreditUnits
	async getPriceForCreditUnits(sessionuuid, currencyuuid, creditunits) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var swapmodule = global.getModuleObject('uniswap');

		var scheme = await this._getCurrencyScheme(session, currency);

		// compute corresponding ethereum credits
		var ethnodemodule = global.getModuleObject('ethnode');

		var avg_transaction_fee = this._getAverageTransactionFee(scheme)

		var weiamount = ethnodemodule.getWeiFromEther(avg_transaction_fee);
		var ethamount = await this._createDecimalAmount(session, weiamount, 18);
		ethamount.multiply(creditunits);
		
		var ethcredit = await ethamount.toInteger();

		// token info
		var uniswap_v2 = currency.uniswap_v2;
		uniswap_v2.version = 'uniswap_v2';

		var token = {};
		token.name = currency.name;
		token.address = currency.address;
		token.symbol = currency.symbol;
		token.decimals = currency.decimals;

		var weth = {};
		weth.name = uniswap_v2.gas_name;
		weth.address = uniswap_v2.gas_address;
		weth.symbol = uniswap_v2.gas_symbol;
		weth.decimals = uniswap_v2.gas_decimals;

		var pricing = await swapmodule.getPriceForOutput(session, scheme, token, weth, ethcredit, uniswap_v2);

		var priceamount = (pricing.amounts_in ? pricing.amounts_in[0] : null)

		var price_struct = {};

		price_struct.creditunits_requested = creditunits;
		price_struct.currency_amount = await this._createCurrencyAmount(session, currency, (priceamount ? priceamount : -1));

		return price_struct;
	}

	// TODO: should use mvccurrencies.buyCreditUnits
	async buyCreditUnits(sessionuuid, walletuuid, carduuid, currencyuuid, creditunits, feelevel = 0) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!walletuuid)
		return Promise.reject('wallet uuid is undefined');
	
		if (!carduuid)
		return Promise.reject('card uuid is undefined');
	
		if (!currencyuuid)
		return Promise.reject('currency uuid is undefined');
	
		var global = this.global;
		var mvcmodule = global.getModuleObject('mvc');
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var wallet = await _apicontrollers.getWalletFromUUID(session, walletuuid);
		
		if (!wallet)
			return Promise.reject('could not find wallet ' + walletuuid);
		
		var card = await wallet.getCardFromUUID(carduuid);
		
		if (!card)
			return Promise.reject('could not find card ' + carduuid);

		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var swapmodule = global.getModuleObject('uniswap');

		var scheme = await this._getCurrencyScheme(session, currency);

		var cardsession = await this._getMonitoredCardSession(session, wallet, card);
		var fromaccount = card._getSessionAccountObject();

		// compute corresponding ethereum credits
		var ethnodemodule = global.getModuleObject('ethnode');

		var avg_transaction_fee = this._getAverageTransactionFee(scheme)

		var weiamount = ethnodemodule.getWeiFromEther(avg_transaction_fee);
		var ethamount = await this._createDecimalAmount(session, weiamount, 18);
		ethamount.multiply(creditunits);
		
		var ethcredit = await ethamount.toInteger();

		// token info
		var uniswap_v2 = currency.uniswap_v2;
		uniswap_v2.version = 'uniswap_v2';

		var token = {};
		token.name = currency.name;
		token.address = currency.address;
		token.symbol = currency.symbol;
		token.decimals = currency.decimals;

		var currencyposition = await this.getCurrencyPosition(sessionuuid, walletuuid, currencyuuid, carduuid);
		var tokenamountmax = await currencyposition.toInteger();

		var weth = {};
		weth.name = uniswap_v2.gas_name;
		weth.address = uniswap_v2.gas_address;
		weth.symbol = uniswap_v2.gas_symbol;
		weth.decimals = uniswap_v2.gas_decimals;

		// create ethereum transaction object
		//var ethtx = _apicontrollers.createEthereumTransaction(cardsession, fromaccount);
		var ethtx = await this._createMonitoredEthereumTransaction(wallet, card, cardsession, fromaccount);

		ethtx.setToAddress(fromaccount.getAddress()); // ask to send credits to card

		// fee
		var fee = await _apicontrollers.createSchemeFee(scheme, feelevel);
			
		let units_per_swap_transfer = 3;
		let gaslimit = fee.gaslimit * units_per_swap_transfer;

		ethtx.setGas(gaslimit);
		ethtx.setGasPrice(fee.gasPrice);

		// send swap request
		return swapmodule.buyEthOnOutput(cardsession, scheme, token, tokenamountmax, weth, ethcredit, uniswap_v2, ethtx);
	}

	//
	// utils
	//
	async _unformatAmount(session, amountstring, decimals) {
		if (amountstring === undefined)
			return;
		
		var _amountstring = amountstring.trim();

		// remove trailing symbol if some
  		var index = _amountstring.indexOf(' ');
		if ( index > 0)
		_amountstring = _amountstring.substring(0, index);

		if ((!_amountstring) || isNaN(_amountstring))
			return -1;
		
		
		var split = amountstring.toString().split(".");
		var amountnumberstring;
		
		if (typeof split[1] === 'undefined') {
			// no decimal
			var multiplier = '';
			for (var i = 0; i < decimals; i++) multiplier += '0';
	
			amountnumberstring = _amountstring + multiplier;
		}
		else {
			var integerstring = split[0];
			
			if (split[1].length < decimals) {
				integerstring += split[1];
				// fill with trailing zeros
				for (var i = 0; i < (decimals - split[1].length); i++)
					integerstring += '0';
			}
			else {
				integerstring += split[1].substr(0, decimals);
			}
			
			amountnumberstring = integerstring;
		}
		
		return amountnumberstring;
	}

	async _formatAmount(session, amount, decimals, options) {
		if (amount === undefined)
			return;
		
		var _inputamountstring = amount.toString();
		var amountstring;
		
		if (_inputamountstring.length > decimals) {
			// integer part
			var integerpart = _inputamountstring.substring(0, _inputamountstring.length - decimals);

			amountstring = integerpart + '.' + _inputamountstring.substring(_inputamountstring.length - decimals);
		}
		else {
			var leading = '';
			for (var i = 0; i < (decimals -_inputamountstring.length) ; i++) leading += '0';
			amountstring = '0.' + leading + _inputamountstring;
		}

		if (options) {
			if (typeof options.showdecimals !== 'undefined') {
				if (options.showdecimals === false) {
					// we remove . and after
					amountstring = amountstring.substring(0, amountstring.indexOf('.'));
				}
				else {
					var decimalsshown = (options.decimalsshown ? options.decimalsshown : decimals);
					amountstring = amountstring.substring(0, amountstring.indexOf('.') + 1 + decimalsshown);
				}

			}
		}

		return amountstring;
	}
	

	async _formatMonetaryAmount(session, amount, symbol, decimals, options) {
		var amountstring = await this._formatAmount(session, amount, decimals, options);
		
		return amountstring + ' ' + symbol;
	}

	async _formatTokenAmount(session, tokenamount, token, options) {
		// TODO: unsupported calls that would need to be
		// wrapped up in a token.init function
		var erc20contrat = token._getERC20TokenContract(session); // necessary for _synchronize
		await token._synchronizeERC20TokenContract(session);
		// TODO: end
		
		var decimals = token.getDecimals();
		var symbol = token.getSymbol();
		
		var amountstring = await this._formatMonetaryAmount(session, tokenamount, symbol, decimals, options);
		
		return amountstring;
	}

	// TODO: should use mvccurrencies.getDecimalAmount
	async getDecimalAmount(sessionuuid, amount, decimals = 18) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		return this._createDecimalAmount(session, amount, decimals);
	}

	// TODO: should use mvccurrencies.getCurrencyAmount
	async getCurrencyAmount(sessionuuid, currencyuuid, amount) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var mvcmodule = global.getModuleObject('mvc')
	
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var decimals = currency.decimals;
		let tokenamountstring;
		
		if (typeof amount === 'string'){
			tokenamountstring = await this._unformatAmount(session, amount, decimals);
		}
		else if (Number.isInteger(amount)) {
			tokenamountstring = mvcmodule.formatAmount(amount, decimals)
		} 
		else {
			let isFloat = (n) => {
				return Number(n) === n && n % 1 !== 0;
			};

			if (isFloat(amount)) {
				let amountstring = amount.toString();
				tokenamountstring = await this._unformatAmount(session, amountstring, decimals);
			}
			else {
				return Promise.reject('amount is not correct: ' + amount);
			}
		}

		return this._createCurrencyAmount(session, currency, tokenamountstring);
	}
	
	// TODO: should use mvccurrencies.formatCurrencyAmount
	async formatCurrencyAmount(sessionuuid, currencyuuid, currencyamount, options) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!currencyuuid)
			return Promise.reject('currency uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();
	
		var CurrencyAmountClass = global.getModuleClass('currencies', 'CurrencyAmount');
		if ((currencyamount instanceof CurrencyAmountClass) !== true)
			return Promise.reject('wrong currency amount type');
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);
	
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
		
		var currency = await this.getCurrencyFromUUID(sessionuuid, currencyuuid);
		
		if (!currency)
			return Promise.reject('could not find currency ' + currencyuuid);

		var _options = (options ? options : {showdecimals: true, decimalsshown: 2});

		// TEST
/* 		var currencyscheme = await this._getCurrencyScheme(session, currency);
		var tokenaddress = currency.address;

		var token = await currencyscheme.getTokenObject(tokenaddress);
		
		var currencyamountstring = await this._formatTokenAmount(session, tokenamount, token, _options);
 */		// TEST: end

 		var tokenamountstring = await currencyamount.toString();
		var currencyamountstring = await this._formatMonetaryAmount(session, tokenamountstring, currency.symbol, currency.decimals, _options);

		return currencyamountstring;
	}
}

if ( (typeof GlobalClass === 'undefined') || (!GlobalClass)) {
	var GlobalClass = ((typeof window !== 'undefined') && window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}

if ( typeof GlobalClass !== 'undefined' && GlobalClass ) {
	GlobalClass.getGlobalObject().registerModuleObject(new Module());

	//dependencies
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-myquote', 'common');
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-myquote', 'mvc');

	// module classes	
	//GlobalClass.registerModuleClass('mvc-myquote', 'DecimalAmount', DecimalAmount);
	//GlobalClass.registerModuleClass('mvc-myquote', 'CurrencyAmount', CurrencyAmount);
}


